import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { history } from './modules/router';

import api from './api';
import rootReducer from './reducers';

const router = routerMiddleware(history);

const configureStore = () => {
  const middlewares = [thunk, router,  api];

  if(process.env.NODE_ENV !== 'development') {
    return createStore(
      rootReducer,
      applyMiddleware(...middlewares)
    );
  }
  return createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(...middlewares)
  );
  
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/configureStore.js